import { ZoneModel } from '@app/models/ZoneModel';
import { ZoneRepository } from '@app/repositories/ZoneRepository';
import { ServiceBase } from '@app/services/ServiceBase';

export class ZoneService extends ServiceBase<ZoneModel, ZoneRepository<ZoneModel>> {
    public constructor() {
        super(new ZoneRepository());
    }
}
